// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wu4oyQV0493ZtKoPSPei,.JdC4HJ2aFWNXVaq65qvE{font-size:18px;margin-top:20px;order:1;width:60%}.do6Np1AA5c6jCiwa3ylq{font-size:14px;margin-top:40px}.I3C8nYQcCm0KHxr9tYlH{display:flex}.I3C8nYQcCm0KHxr9tYlH svg{margin-top:5px}.cuzULGkSO_UlRz_MeCYK{padding-left:5px;padding-right:5px}@media screen and (max-width: 767px){.JdC4HJ2aFWNXVaq65qvE{font-size:14px;margin-top:20px;width:100%}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scheduleSubtitle": `wu4oyQV0493ZtKoPSPei`,
	"scheduleSubtitle": `JdC4HJ2aFWNXVaq65qvE`,
	"scheduleCompositeprogramlist": `do6Np1AA5c6jCiwa3ylq`,
	"scheduleCompositesaved": `I3C8nYQcCm0KHxr9tYlH`,
	"scheduleCompositeunsaved": `cuzULGkSO_UlRz_MeCYK`
};
module.exports = ___CSS_LOADER_EXPORT___;
